export class Vehiculo
{
    matricula:string="";
    eurocode:string="";
    oem:string = "";
    km:string="";
    marca:string="";
    modelo:string="";
    bastidor:string="";
    any:string="";
    descSiniestro:string="";
    puertas:string="";
    trabajos:string="";
    color:string="";
    matriculacion: string = "";
    precio: number = 0;
}
